/**
 * Created by jv on 2019-11-22 (10:42).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import extraProductReductionImage from "Images/icons/events/event-extra_product_reduction.png";
import arrow from "!raw-loader!Images/icons/btn_arrow.svg";

const eventIcons = require.context("!raw-loader!Images/icons/events", false, /\.svg$/);

require("Styles/components/event-panel.scss");

class EventPanel {
  constructor(options) {
    if (utils.isNull(options)) options = {};

    this._event = options.event;
    this.appendTo = $(options.appendTo);
  }

  get event() {
    return this._event;
  }

  set event(event) {
    this._event = event;
    this.render();
  }

  render() {
    if (utils.isNull(this.event)) return;

    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.destroy();
    }

    this.$element = $("<div class='event-panel'></div>");
    this.$element.data("event-type", this.event.type);

    log.debug("Setting up event panel for event - %o", this.event);

    let $eventPanelTop = $("<div class='event-panel__top'></div>");

    let icon = EventPanel.getEventIconForEvent(this.event);
    let $eventIcon = $("<div class='event-panel__icon'></div>");
    if (utils.isNotNull(icon)) {
      $eventIcon.append(icon);
    }

    $eventPanelTop.append($eventIcon);
    $eventPanelTop.append(`<h4 class="event-panel__title">${this.event.title}</h4>`);

    let $eventPanelBottom = $("<div class='event-panel__bottom'></div>");

    let $eventDataHtml = EventPanel.getHtmlForEvent(this.event);

    if (utils.isNotNull($eventDataHtml)) {
      $eventPanelBottom.append($eventDataHtml);
    }

    this.$element.append($eventPanelTop);
    this.$element.append($eventPanelBottom);

    this.$element.appendTo(this.appendTo);
  }

  destroy() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.remove();
    }
  }

  show() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.show();
    }
  }

  hide() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.hide();
    }
  }

  static getEventIconForEvent(event) {
    let eventIconKey = `./${event.type}.svg`;
    if (eventIcons.keys().includes(eventIconKey)) {
      return eventIcons(eventIconKey);
    }

    return null;
  }

  static getHtmlForEvent(event) {
    switch (event.type) {
      case "energy":
        return EventPanel.getEnergyHtml(event);
      case "tax":
        return EventPanel.getTaxHtml(event);
      case "tradewar":
        return EventPanel.getTradeWarHtml(event);
      case "subsidy":
        return EventPanel.getSubsidyHtml(event);
    }

    return null;
  }

  static getEnergyHtml(event) {
    let $eventData = $("<div class='event-panel__impact'></div>");
    $eventData.addClass(`event-type__${event.type}`);

    $eventData.append(`<p>${event.jsonData.text1}</p>`);
    $eventData.append(`<p>${event.jsonData.text2}</p>`);

    let $eventDataGroup = $("<div class='ep__data-group'></div>");
    $eventDataGroup.append(`<div class='ep__data-value event-data event-data__budget'>${event.jsonData.value}</div>`);
    $eventDataGroup.append(`<div class='ep__data-label'>${LanguageManager.getValueForKey("serious_game.business_model.events.labels.per_product")}</div>`);

    $eventData.append($eventDataGroup);

    return $eventData;
  }

  static getTaxHtml(event) {
    let $eventData = $("<div class='event-panel__impact'></div>");
    $eventData.addClass(`event-type__${event.type}`);

    $eventData.append(`<p>${event.jsonData.text}</p>`);

    let $eventDataGroups = $("<div class='ep__data-groups'></div>");

    let $leftCol = $("<div class='ep__data-group-col'></div>");
    let $rightCol = $("<div class='ep__data-group-col'></div>");

    event.jsonData.values.sort(function (v1, v2) {
      return v1.index - v2.index;
    });

    for (let i = 0; i < event.jsonData.values.length; i++) {
      let valueGroup = event.jsonData.values[i];

      let pointRange;

      if (i === event.jsonData.values.length - 1) {
        // Last
        pointRange = `${valueGroup.min}+`;
      } else {
        pointRange = `${valueGroup.min}-${valueGroup.max - 1}`;
      }

      let $eventDataGroup = $("<div class='ep__data-group'></div>");
      $eventDataGroup.append(`<div class='ep__data-value event-data event-data__points'>${pointRange}</div>`);
      $eventDataGroup.append(`<div class='ep__data-connector'>${arrow}</div>`);
      $eventDataGroup.append(`<div class='ep__data-value event-data event-data__budget'>${Math.abs(valueGroup.value)}</div>`);

      if (i < Math.ceil(event.jsonData.values.length / 2)) {
        $leftCol.append($eventDataGroup);
      } else {
        $rightCol.append($eventDataGroup);
      }
    }

    $eventDataGroups.append($leftCol);
    $eventDataGroups.append($rightCol);

    $eventData.append($eventDataGroups);

    return $eventData;
  }

  static getTradeWarHtml(event) {
    let $eventData = $("<div class='event-panel__impact'></div>");
    $eventData.addClass(`event-type__${event.type}`);

    $eventData.append(`<p>${event.jsonData.text1}</p>`);

    let sign = "";

    if (event.jsonData.value1 > 0) {
      sign = "+"
    }

    let $eventDataGroup = $("<div class='ep__data-group'></div>");
    $eventDataGroup.append(`<div class='ep__data-value event-data event-data__budget'>${sign}${event.jsonData.value1}</div>`);
    $eventDataGroup.append(`<div class='ep__data-label'>${LanguageManager.getValueForKey("serious_game.business_model.events.labels.per_product")}</div>`);

    $eventData.append($eventDataGroup);

    sign = "";

    if (event.jsonData.value2 > 0) {
      sign = "+"
    }

    $eventData.append(`<p>${event.jsonData.text2}</p>`);

    $eventDataGroup = $("<div class='ep__data-group'></div>");
    $eventDataGroup.append(`<div class='ep__data-value event-data event-data__budget'>${sign}${event.jsonData.value2}</div>`);
    $eventDataGroup.append(`<div class='ep__data-label'>${LanguageManager.getValueForKey("serious_game.business_model.events.labels.per_product")}</div>`);

    $eventData.append($eventDataGroup);

    return $eventData;
  }

  static getSubsidyHtml(event) {
    let $eventData = $("<div class='event-panel__impact'></div>");
    $eventData.addClass(`event-type__${event.type}`);

    $eventData.append(`<p>${event.jsonData.text}</p>`);

    let $eventDataGroup = $("<div class='ep__data-group'></div>");
    $eventDataGroup.append(`<img src='${extraProductReductionImage}' alt=''/>`);
    $eventDataGroup.append(`<div class='ep__data-label'>${LanguageManager.getValueForKey("serious_game.business_model.events.labels.cost")}</div>`);
    $eventDataGroup.append(`<div class='ep__data-value event-data event-data__budget'>${event.jsonData.value}</div>`);

    $eventData.append($eventDataGroup);

    return $eventData;
  }
}

export default EventPanel;



// WEBPACK FOOTER //
// ./app/js/components/game/components/event-panel.js